import { render, staticRenderFns } from "./FrontPage.vue?vue&type=template&id=e4c16d28&scoped=true&"
var script = {}
import style0 from "./FrontPage.vue?vue&type=style&index=0&id=e4c16d28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c16d28",
  null
  
)

export default component.exports